import "./customDateInput.sass";

const CustomDateInput = ({ label, value, name, onChange }) => {
  return (
    <>
      <div className="form-group">
        <div className="custom-label fw-bold d-flex " style={{ color: "#CACCFC" }}>
          {label}
        </div>
        <input id="dateInput" className="form-control ps-0 pb-0 pe-0 custom-input-date " type="date" name={name} value={value} onChange={onChange} />
      </div>
      <div className="input-underline" />
    </>
  );
};

export default CustomDateInput;
